import React from 'react'

const Thirty = () => {
    return (
        <div className='container'>
            <h1>Print & Read elements in Array</h1>
            <div className='containers'>
           <pre> {`input: 
            Enter the size of array: 5 
            Enter 5 elements in the array: 9
                8
                7
                6
                5
 
Elements in array are: 9  8  7  6  5`}</pre>

            </div>
            <h3>Logic to Print & Read elements in Array </h3>
         
              <pre>{`A function which calls itself until some condition is called recursive function.
2) The function input() calls itself recursively by increasing i value until i<n.

The function output() calls recursively by increasing i value until i<n.

3) The main() calls the input() as input(a,0,n) to read the entered elements.

a) The input() checks the condition i<n,

If the condition is true then it reads the entered element,initialized to a[i] using scanf() function and the function input() calls itself by increasing i value.

4) The main() calls the output() as output(a,0,n) to print the array elements.

a) The output() checks the condition i<n,

If the condition is true then it prints the array element a[i] using printf() function and the function output() calls itself by increasing i value by 1`}</pre>

           
            <div className='containers'>
          <code className='library'>#include</code>   &lt;conio.h&gt; <br />
          <br />
          <code className='keywords'>input</code>(int *a,int i,int n)<br />
 &#123; <br />
 <br />
 <code className='keywords'> if</code>(i&lt;n)<br />
     &#123;<br />
     <code className='library'>   scanf</code>("%d", &a[i]);<br />
     <code className='keywords'>   input</code>(a,i+1,n);<br />
     &#125; <br />
     <br /><br />
     <br />
           
 &#125;<br />
 <br /><br />
 <code className='keywords'>output</code>(int *a,int i,int n)<br />
 &#123; <br />
 <code className='keywords'>   if</code>(i&lt;n)<br />
     &#123;<br />
     <code className='library'>    printf</code>("%d  ", a[i]);<br />
     <code className='keywords'>   output</code>(a,i+1,n);<br />
     &#125; <br />
     <br /><br /><br /><br />
          
   
  
           
 &#125;<br /><br /><br />
  
  
  
 <code className='keywords'>int </code>main()<br />
 &#123;<br />
 <code className='keywords'>   int</code> a[1000],i,n; <br /> 
 <br />
 <code className='library'> printf</code>("Enter size of array: ");<br />
 <code className='library'> scanf</code>("%d",&n);<br />
 <br />
 <code className='library'> printf</code>("Enter %d elements in the array : ", n);<br />
 <code className='keywords'> input</code>(a,0,n);<br />
 <code className='library'> printf</code>("\nElements in array are: ");<br />
 <code className='keywords'> output</code>(a,0,n);<br /><br />
  
 <code className='library'> return </code>0;<br />
 &#125;<br />
            </div>
        </div>
    )
}

export default Thirty
